import _ from 'lodash';
import sessionReducer from '../reducers/session/session-reducer';
import {connect, reducerAndActionsFor} from '@symbolic/react-app/src/redux/helpers/helpers'
import createGenericStore from '@symbolic/react-app/src/redux/helpers/create-generic-store';

var createStore = ({reducers, withSession=true, ...params}={}) => {
  if (withSession) reducers = {...reducers, session: sessionReducer};

  return createGenericStore({reducers, ...params});
};

export {connect, reducerAndActionsFor, createStore};
